import React, { useContext, useMemo } from "react";

import { AuthContext } from "shared/context/auth-context";
import { useTranslation } from "react-i18next";

import InventoryVehicles from "features/inventory/inventory-vehicles/InventoryVehicles";
import InventoryDrivers from "features/inventory/inventory-drivers/InventoryDrivers";
import InventoryAttendants from "features/inventory/inventory-attendants/InventoryAttendants";
import StockMovements from "features/inventory/inventory-stocks/managed-stocks/stock-movements/StockMovements";
import InventoryStocksList from "features/inventory/inventory-stocks/InventoryStocksList";
import InventoryAccidents from "features/inventory/inventory-accidents/InventoryAccidents";
import InventoryMaintenances from "features/inventory/inventory-maintenance/InventoryMaintenances";
import InventoryThirdParties from "features/inventory/inventory-third-parties/InventoryThirdParties";
import InventoryFuels from "features/inventory/inventory-fuels/InventoryFuels";
import InventoryReports from "features/inventory/inventory-reports/InventoryReports";

import Tabs from "components/ui/tabs/Tabs";

const InventoryPage = () => {
  const { t } = useTranslation();
  const auth = useContext(AuthContext);

  if (!auth.permissions.accessToInventory) {
    return <div className="center">{t("inventoryTabs.noAccess")}</div>;
  }

  const accountingTabs = useMemo(() => {
    let allTabs = [];

    allTabs.push({
      label: t("inventoryTabs.ownedVehicles"),
      content: <InventoryVehicles ownershipFilter="owned" />,
    });

    allTabs.push({
      label: t("inventoryTabs.rentedVehicles"),
      content: <InventoryVehicles ownershipFilter="rented" />,
    });

    allTabs.push({
      label: t("inventoryTabs.companyDrivers"),
      content: <InventoryDrivers employmentFilter="company" />,
    });

    allTabs.push({
      label: t("inventoryTabs.externalDrivers"),
      content: <InventoryDrivers employmentFilter="external" />,
    });

    allTabs.push({
      label: t("inventoryTabs.attendants"),
      content: <InventoryAttendants />,
    });

    // allTabs.push({
    //   label: t("Zimmet Yönetimi"),
    //   content: <InventoryCustodies />,
    // });

    allTabs.push({
      label: t("inventoryTabs.stockManagement"),
      content: <InventoryStocksList />,
    });

    allTabs.push({
      label: t("inventoryTabs.allStockMovements"),
      content: <StockMovements />,
    });

    allTabs.push({
      label: t("inventoryTabs.accidents"),
      content: <InventoryAccidents />,
    });

    allTabs.push({
      label: t("inventoryMaintenance.tabLabel"),
      content: <InventoryMaintenances />,
    });

    allTabs.push({
      label: t("inventoryThirdParty.tabLabel"),
      content: <InventoryThirdParties />,
    });

    allTabs.push({
      label: t("inventoryTabs.fuelPayments"),
      content: <InventoryFuels />,
    });

    allTabs.push({
      label: t("inventoryTabs.reports"),
      content: <InventoryReports />,
    });

    return allTabs;
  }, [t]);

  return (
    <React.Fragment>
      <Tabs tabs={accountingTabs} isVertical={true} />
    </React.Fragment>
  );
};

export default InventoryPage;
